module.exports = __webpack_public_path__ + "static/media/trophy@3x.4a5bc936.png";